/** @flow */

import React, { Component } from "react";
import Chart from "react-google-charts";
import classNames from "classnames";
import type { ChartWrapperOptions } from "react-google-charts";
import { chartDefaultColors } from "@styles/colors";

const pieOptions: ChartWrapperOptions = {
  legend: {
    position: "bottom",
  },
  chartArea: {
    top: 40,
  },
  colors: chartDefaultColors,
  seriesType: "bars",
};

export type Props = $Exact<{
  options?: Object,
  title?: string,
  fullWidth?: boolean,
  disableBorder?: boolean,
  values: Array<Array<string | number | Object>>,
  legendToggle?: boolean,
  isComboChart?: boolean,
  chartProps?: Object,
}>;

export class BarChart extends Component<Props> {
  chartWrapper = null;

  onResize = () => {
    this.chartWrapper && this.chartWrapper.draw();
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <div
        className={classNames("item-container chart-block bar-chart mt-3 pt-3", {
          "full-width": this.props.fullWidth,
          "disable-border": this.props.disableBorder,
        })}
      >
        {this.props.title ? (
          <div className="chart-title mb-4 text-center">{this.props.title}</div>
        ) : null}
        {this.props.values.length > 1 ? (
          <Chart
            {...this.props.chartProps}
            chartType={this.props.isComboChart ? "ComboChart" : "ColumnChart"}
            data={this.props.values}
            getChartWrapper={chartWrapper => {
              this.chartWrapper = chartWrapper;
            }}
            options={Object.assign({}, pieOptions, this.props.options)}
            legendToggle={this.props.legendToggle}
          />
        ) : (
          <div className="w-100 text-center">No data</div>
        )}
      </div>
    );
  }
  static defaultProps = {
    options: {},
  };
}

export default BarChart;
